import { Box, Text } from "@mantine/core";
import { IconBan } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

type PrivateMessageProps = {
  message?: string | null;
  time?: string | null;
  attachments?: React.ReactNode;
  isEdited?: boolean;
  isDeleted?: boolean;
};

const PrivateMessage = ({
  message,
  time,
  attachments,
  isEdited,
  isDeleted,
}: PrivateMessageProps) => {
  const { t } = useTranslation("messages");
  return (
    <Box className="flex justify-start">
      <Box className="px-[7px] m-2 rounded-lg max-w-[85%] min-w-[20%] rounded-tl-none rounded-tr-[7px] rounded-bl-[7px] rounded-br-[7px] wrap-break-word whitespace-pre-wrap bg-white">
        {!isDeleted && attachments}
        {isDeleted ? (
          <Box className="flex items-center gap-1">
            <IconBan size={20} color="var(--color-gray-medium)" />
            <Text fz={"md"} c="var(--color-gray-medium)">
              {t("messageDeleted")}
            </Text>
          </Box>
        ) : (
          <Text fz={"md"} c="var(--color-gray-dark)">
            {message}
          </Text>
        )}
        {time ? (
          <Box className="flex items-center justify-end gap-1 h-2.5 pb-1">
            {isEdited && !isDeleted && (
              <Text fz={12} c={"var(--color-gray)"}>
                {t("edited")}
              </Text>
            )}
            <Text fz={12} c={"var(--color-gray)"}>
              {time}
            </Text>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default PrivateMessage;
